import * as React from 'react'
import Link from 'gatsby-link'
import { Text, Switch, Box, Subhead, Flex } from 'rebass'
import { SocialIcon } from 'react-social-icons'
import DarkMode from './DarkMode'
class SocialLinks extends React.PureComponent<{}, {}> {
  render() {
    const style = { height: '25px', width: '25px' }
    return (
      <Flex
        width={'100%'}
        mt={['2.5rem', '2.5rem', 'auto', 'auto']}
        justifyContent={'space-between'}
      >
        <SocialIcon style={style} url={'https://www.twitter.com/brandonmp44'} />
        <SocialIcon style={style} url={'mailto:homepage@brandon.sh'} />
        <SocialIcon
          style={style}
          url={'https://www.linkedin.com/in/bmpaquette/'}
        />
      
        <SocialIcon
          style={style}
          color={'black'}
          url={'https://github.com/brandonmp'}
        />
      </Flex>
    )
  }
}

const links = [
  {
    label: 'writing',
    to: '/writing/',
    renderChildren: ({ blogPosts }) => (
      <Flex pl={2} flexDirection={'column'}>
        {blogPosts.map(p => (
          <Box mb={4} key={p.fields.slug}>
            <Link to={p.fields.slug}>
              <h4
                style={{ marginBottom: 0, color: 'inherit', fontWeight: 400 }}
              >
                {p.frontmatter.title}
              </h4>
            </Link>
            <Text style={{ fontStyle: 'italic' }} p={2} pt={0} fontSize={1}>
              {p.frontmatter.summary}
            </Text>
          </Box>
        ))}
        <Link style={{ marginLeft: 'auto' }} to={'/writing/'}>
          More >>
        </Link>
      </Flex>
    ),
  },
]

class HeaderLink extends React.PureComponent<
  { to?: string; children: React.ReactNode },
  {}
> {
  render() {
    return (
      <Link
        style={{
          fontVariantCaps: 'all-petite-caps',
          textDecoration: 'none',
          color: 'black',
          marginLeft: '1rem',
          marginRight: '1rem',
        }}
        to={this.props.to}
      >
        <Subhead
          style={{
            textAlign: 'right',
            borderBottom: '2px solid black',
          }}
        >
          {this.props.children}
        </Subhead>
      </Link>
    )
  }
}

class Header extends React.PureComponent {
  render() {
    return (
      <Flex
        width={'300px'}
        p={2}
        px={4}
        mx={['auto', 'auto', 0, 0]}
        style={{ height: '100%' }}
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
        flexDirection={'column'}
      >
        <Flex flexDirection={'column'}>
          {links.map(({ label, to, renderChildren }) => (
            <div>
              <HeaderLink to={to}>{label}</HeaderLink>
              {renderChildren && renderChildren(this.props)}
            </div>
          ))}
        </Flex>
        {/* {<DarkMode />} */}
        <SocialLinks />
        <Box mt={2} mx={'auto'} fontSize={1}>
          © 2017 - {new Date().getFullYear()} Brandon Paquette
        </Box>
      </Flex>
    )
  }
}
export default Header



// WEBPACK FOOTER //
// ./src/components/Header.tsx